import React, { createContext, useContext, useState } from 'react';
import { Testimonial } from '@/hooks/useTestimonials';

interface TestimonialDialogContextType {
  isOpen: boolean;
  editingTestimonial: Testimonial | null;
  openDialog: (testimonial?: Testimonial) => void;
  closeDialog: () => void;
}

const TestimonialDialogContext = createContext<TestimonialDialogContextType | undefined>(undefined);

export function TestimonialDialogProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [editingTestimonial, setEditingTestimonial] = useState<Testimonial | null>(null);

  const openDialog = (testimonial?: Testimonial) => {
    setEditingTestimonial(testimonial || null);
    setIsOpen(true);
  };

  const closeDialog = () => {
    setIsOpen(false);
    setTimeout(() => setEditingTestimonial(null), 200);
  };

  return (
    <TestimonialDialogContext.Provider
      value={{ isOpen, editingTestimonial, openDialog, closeDialog }}
    >
      {children}
    </TestimonialDialogContext.Provider>
  );
}

export function useTestimonialDialog() {
  const context = useContext(TestimonialDialogContext);
  if (!context) {
    throw new Error('useTestimonialDialog must be used within TestimonialDialogProvider');
  }
  return context;
}
